import api from './api';

export const PARTY_OPTIONS = [
  { name: 'AK PARTİ MECLİS ÜYESİ', color: '#fffd00' },
  { name: 'MHP MECLİS ÜYESİ', color: '#8B0000' },
  { name: 'CHP MECLİS ÜYESİ', color: '#FF0000' }
];

export const getParlamentMembers = (params) => {
  return api.post('/api/ParlamentMembers/GetParlamentMembers', {
    pageNum: params.pageNum || 1,
    pageSize: params.pageSize || 10,
    searchTerm: params.searchTerm || "",
    sortBy: params.sortBy || "",
    startDate: "2007-03-25T11:47:12.648Z",
    endDate: "2030-04-13T00:37:05.648Z"
  });
};

export const addParlamentMember = (memberData) => {
  return api.post('/api/ParlamentMembers/AddParlamentMembers', memberData);
};

export const updateParlamentMember = (memberData) => {
  return api.post('/api/ParlamentMembers/UpdateParlamentMembers', memberData);
};

export const deleteParlamentMember = (guid) => {
  return api.post('/api/ParlamentMembers/DeleteParlamentMembers', { guid });
};
